import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LoginFlowSlice {
  email: string;
  redirect?: string;
}
const initialState: LoginFlowSlice = {
  email: "",
  redirect: undefined,
};

export const loginFlowSlice = createSlice({
  name: "loginFlow",
  initialState,
  reducers: {
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setRedirect: (state, action: PayloadAction<string>) => {
      state.redirect = action.payload;
    },
  },
});

export const { setEmail, setRedirect } = loginFlowSlice.actions;
export default loginFlowSlice.reducer;
